import React from 'react';

/**
 * Standalone-viewer placeholder.
 *
 * Substituted (via the trimmed object-types/field-types barrels) for node
 * types that require a backend, a native environment, or the Form Builder
 * editor and therefore cannot render in the no-backend standalone viewer:
 *   - upload / single-upload  (file upload service)
 *   - field-editor / field-group-editor (admin Form Builder editor surface)
 *
 * It renders a clearly-labeled, inert box instead of pulling those subtrees
 * into the bundle. The component accepts (and ignores) the usual node props.
 */
const LABELS = {
  upload: 'File upload',
  'single-upload': 'File upload',
  field: 'Field editor',
  'field-group': 'Field-group editor',
};

const Placeholder = props => {
  const { title, field_type: fieldType, type } = props || {};
  const kind = LABELS[fieldType] || LABELS[type] || 'Unsupported element';
  return (
    <div
      data-testid="viewer-placeholder"
      style={{
        border: '1px dashed #bfbfbf',
        borderRadius: 4,
        padding: '10px 12px',
        margin: '4px 0',
        color: '#8c8c8c',
        background: '#fafafa',
        fontSize: 13,
      }}
    >
      {title ? <strong style={{ color: '#595959' }}>{title}</strong> : null}
      <div>{kind} — disabled in standalone viewer</div>
    </div>
  );
};

export default Placeholder;
